import { render } from "./tradeFutures.vue?vue&type=template&id=2682540a"
import script from "./tradeFutures.vue?vue&type=script&lang=js"
export * from "./tradeFutures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__